import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  addQuizRequest,
  addQuizRequestError,
  addQuizRequestSuccess,
} from "../../../slices/teams/members/AddQuizSlice";
export const AddQuiz = (formData) => async (dispatch) => {
  try {
    dispatch(addQuizRequest());
    const url = endpoints.addQuiz;
    // Send FormData directly (for image + JSON payload)
    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(addQuizRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to add quiz";

    const _error = {
      data: errorMessage,
      status: error?.response?.status,
    };

    dispatch(addQuizRequestError(_error));
    throw _error;
  }
};
